import styled, { css } from 'styled-components';
import color from '../../configs/color';

const Wrapper = styled.div`
  width: 100%;
  border-radius: 8px;
  padding: 8px 12px 8px 8px;
  border: 1px solid ${color.grey1};
  transition: 0.3s ease;
  ${(props) => {
    return (
      props.with_hover &&
      css`
        :hover {
          border-color: ${color.green1};
        }
      `
    );
  }}

  ${(props) => {
    return (
      props.disabled &&
      css`
        background-color: ${color.grey1};
        :hover {
          border-color: ${color.green1};
        }
      `
    );
  }}

  .component_post_image {
    height: 84px;
    width: 84px;
    border-radius: 8px;
    background-color: ${color.black4};
    overflow: hidden;
    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
  }

  &.isSelected {
    border-color: ${color.green1};
  }
`;

export default Wrapper;
